import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`目前任職於 meepShop 擔任後端工程師。DDDTW 社群志工，同時也是社群講師。曾在 IT 鐵人賽寫過數篇得獎系列文章如「Think in GraphQL」、「Think in Domain-Driven Design」`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      